'use strict';

var _ = require('lodash');

/**
 * Overlapping Resolution Service
 * @constructor
 */
var OverlappingResolutionService = function OverlappingResolutionService() {
  /**
   * Checks if rectangles overlap
   * @param rect1
   * @param rect2
   */
  function doRectanglesOverlap(rect1, rect2) {
    return rect1.x < rect2.x + rect2.width && rect1.x + rect1.width > rect2.x && rect1.y < rect2.y + rect2.height && rect1.height + rect1.y > rect2.y;
  }

  /**
   * Detects first overlapping within data points collection
   * Data point can be single indicator or rectangle containing multiple indicators
   *
   * @param dataPoints
   * @return {*} indexes of overlapping points
   */
  function detectOverlapping(dataPoints) {
    for (var i = 0; i < dataPoints.length - 1; i++) {
      for (var j = i + 1; j < dataPoints.length; j++) {
        var a = dataPoints[i];
        var b = dataPoints[j];
        if (doRectanglesOverlap(a, b)) {
          return [i, j];
        }
      }
    }
    return [];
  }

  /**
   * Transforms single data point to array
   * @param labelPropertyName
   * @param xPropertyName
   * @param yPropertyName
   * @param dataPoint
   * @return {*[]}
   */
  function transformDataPointToArray(labelPropertyName, xPropertyName, yPropertyName, dataPoint) {
    return [{
      label: dataPoint[labelPropertyName],
      className: dataPoint.className,
      textY: dataPoint.textY,
      xPropertyValue: dataPoint[xPropertyName],
      yPropertyValue: dataPoint[yPropertyName]
    }];
  }

  /**
   * Merges two data points into one data point for bigger rectangle
   * @param a
   * @param b
   * @param labelPropertyName
   * @param xPropertyName
   * @param yPropertyName
   */
  function mergeDataPoints(a, b, labelPropertyName, xPropertyName, yPropertyName) {
    var transformFn = transformDataPointToArray.bind(undefined, labelPropertyName, xPropertyName, yPropertyName);
    a.labels = a.labels || transformFn(a);
    b.labels = b.labels || transformFn(b);

    // merge b.labels into a.labels
    _.forEach(b.labels, function (labelData) {
      a.labels.push(labelData);
    });
  }

  /**
   * Positions new rectangle with labels inside
   * @param a
   * @param b
   * @param indicatorSizing
   * @param params
   */
  function resolvePositioning(a, b, indicatorSizing, params) {
    var labelsCount = a.labels.length;
    var rectangleHeight = labelsCount * (indicatorSizing.INDICATOR_SIZE + indicatorSizing.MARGIN) + indicatorSizing.MARGIN;
    var y = _.mean(_.map(a.labels, _.property('textY'))) - rectangleHeight / 2;
    y = Math.max(0 - indicatorSizing.HALF_INDICATOR_SIZE, y);
    y = Math.min(params.height - rectangleHeight + indicatorSizing.HALF_INDICATOR_SIZE, y);
    var textY = y + indicatorSizing.MARGIN + indicatorSizing.HALF_INDICATOR_SIZE;
    var textX = (_.get(a, 'labels[0].textX', a.textX) + _.get(b, 'labels[0].textX', b.textX)) / 2;
    var x = textX - indicatorSizing.HALF_INDICATOR_SIZE - indicatorSizing.MARGIN;
    _.forEach(a.labels, function (labelData, index) {
      labelData.textX = textX;
      labelData.textY = textY + index * (indicatorSizing.INDICATOR_SIZE + indicatorSizing.MARGIN);
    });

    // merge positioning
    a.x = x;
    a.y = y;

    // merge sizing
    a.width = indicatorSizing.INDICATOR_SIZE + 2 * indicatorSizing.MARGIN;
    a.height = rectangleHeight;
  }

  /**
   * Sorts labels in multi-label rectangle with provided sorting function
   * @param dataPoint
   * @param sortingBy
   * @param sortingOrder
   */
  function sortLabels(dataPoint, sortingBy, sortingOrder) {
    if (sortingBy && sortingOrder) {
      dataPoint.labels = _.orderBy(dataPoint.labels, sortingBy, sortingOrder);
    }
  }

  /**
   * Resolves detected overlapping
   * @param argumentsObject
   */
  function resolveOverlapping(argumentsObject) {
    var isOneMorePassNeeded = true;
    while (isOneMorePassNeeded) {
      var overlapping = detectOverlapping(argumentsObject.dataPoints);
      isOneMorePassNeeded = overlapping.length > 0;
      if (isOneMorePassNeeded) {
        var a = argumentsObject.dataPoints[overlapping[0]];
        var b = argumentsObject.dataPoints[overlapping[1]];
        mergeDataPoints(a, b, argumentsObject.labelPropertyName, argumentsObject.xPropertyName, argumentsObject.yPropertyName);
        sortLabels(a, argumentsObject.sortingBy, argumentsObject.sortingOrder);
        resolvePositioning(a, b, argumentsObject.indicatorSizing, argumentsObject.params);

        // overlapping with point b is resolved and we can remove it
        _.pullAt(argumentsObject.dataPoints, overlapping[1]);
      }
    }
  }
  return {
    detectOverlapping: detectOverlapping,
    resolveOverlapping: resolveOverlapping
  };
};
OverlappingResolutionService.$inject = [];
module.exports = OverlappingResolutionService;